module.exports = __webpack_public_path__ + "img/status-bar-unlit.484ac0d7.svg";